export default __webpack_public_path__ + "static/frameElement-LightGreen-1bd3b8327ab261e3363ab6fd8f9a492b.png";